import React from "react";
import Box from "@material-ui/core/Box";
import { FormControlLabel, Typography } from "@material-ui/core";
import { EnumUtils } from "@prestosports/prestostats-core/Common";
import { MatchTiebreakType } from "@prestosports/prestostats-core/Tennis";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import FormControl from "@material-ui/core/FormControl";
import MatchTiebreakSets from "./MatchTiebreakSets";
import MatchTiebreakPoints from "./MatchTiebreakPoints";
import MatchSettings from "./MatchSettings";

const MatchTiebreak = ({
	match,
	onAddSet,
	onRemoveSet,
	onAwayScoreChange,
	onAwayTiebreakChange,
	onHomeScoreChange,
	onHomeTiebreakChange,
	onAwayPointsChange,
	onHomePointsChange,
	onTypeChange = () => {}
}) => {
	const selected = match.matchTiebreakType;
	const maxSetTiebreak = 20;

	return (
		<Box display="flex" flexDirection="column" justifyContent="center">
			<Typography variant="subtitle2">Match Tiebreak</Typography>
			<MatchSettings
				match={match}
				maxTiebreak={maxSetTiebreak}
				showGameType={false}
			/>
			<FormControl>
				<FormControlLabel
					labelPlacement="top"
					control={
						<ToggleButtonGroup
							value={selected}
							exclusive
							onChange={(event, value) => {
								onTypeChange(EnumUtils.getByCode(MatchTiebreakType.default, value));
							}}
							aria-label="Match tiebreak type"
						>
							{MatchTiebreakType.Options.map((option) => (
								<ToggleButton id={option.code} value={option.code}>
									{option.name}
								</ToggleButton>
							))}
						</ToggleButtonGroup>
					}
				/>
			</FormControl>
			<Box style={{ padding: 20 }}>
				{selected === MatchTiebreakType.default.Sets.code && (
					<MatchTiebreakSets
						match={match}
						onAddSet={onAddSet}
						onRemoveSet={onRemoveSet}
						onAwayScoreChange={onAwayScoreChange}
						onAwayTiebreakChange={onAwayTiebreakChange}
						onHomeScoreChange={onHomeScoreChange}
						onHomeTiebreakChange={onHomeTiebreakChange}
						maxSetTiebreak={maxSetTiebreak}
					/>
				)}
				{selected === MatchTiebreakType.default.Points.code && (
					<MatchTiebreakPoints
						match={match}
						onAwayPointsChange={onAwayPointsChange}
						onHomePointsChange={onHomePointsChange}
					/>
				)}
			</Box>
		</Box>
	);
};

export default MatchTiebreak;
